module.exports = {}


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/style-loader.js!./~/weex-vue-loader/lib/style-rewriter.js?id=data-v-4e9a4386!./packages/dof-popover2/colmo.css
// module id = 467
// module chunks = 0 1